import * as Yup from 'yup';

export const schema = Yup.object().shape({});

// 1: عکس بالا - متن پایین,
// 2: عکس راست - متن چپ,
// 3: عکس چپ - متن راست,
// 4: عکس پایین - متن بالا,
// 5: فول عکس,
// 6: فول ویدیو,
// 7: فول تسکت,

// ---------------------------------------------------------------------------------------------------------

const baseSchema = Yup.object().shape({
  NotificationPopupTitlePanel: Yup.string().required('وارد کردن عنوان اعلان در پنل ضروری است'),
  NotificationPopupTitle: Yup.string().required('وارد کردن عنوان اعلان در پروژه ضروری است'),
  NotificationPopupUserLevel: Yup.string().required('وارد کردن سطح کاربر ضروری است'),
  NotificationPopupNumberPerDay: Yup.number().typeError('لطفا یک عدد وارد کنید').positive('مقدار باید مثبت باشد'),
  NotificationPopupMinuteWithDelay: Yup.number().typeError('لطفا مقدار عددی وارد کنید').positive('مقدار باید مثبت باشد'),
  NotificationPopupUrlPrefix: Yup.string().required('وارد کردن NotificationPopupUrlPrefix ضروری است'),
  NotificationBannerUserLevel: Yup.number().typeError('لطفا یک عدد وارد کنید').positive('مقدار باید مثبت باشد'),
  NotificationPopupWidth: Yup.number().required('وارد کردن طول اعلان ضروری است').typeError('لطفا یک عدد وارد کنید').positive('مقدار باید مثبت باشد'),
  NotificationPopupHeight: Yup.number().required('وارد کردن عرض اعلان ضروری است').typeError('لطفا یک عدد وارد کنید').positive('مقدار باید مثبت باشد'),
});

const imageSchema = Yup.object().shape({
  NotificationPopupImageUrl: Yup.string().required('انتخاب تصویر برای اعلان ضروری است'),
  NotificationPopupImageLink: Yup.string().required('وارد کردن لینک تصویر ضروری است'),
});

const bodySchema = Yup.object().shape({
  NotificationPopupBody: Yup.string().required('وارد کردن متن اعلان ضروری است'),
});

const buttonSchema = Yup.object().shape({
  NotificationPopupTitleButton: Yup.string().required('وارد کردن عنوان دکمه ضروری است'),
  NotificationPopupLinkButton: Yup.string().required('وارد کردن لینک دکمه ضروری است'),
});

const linkMp4Schema = Yup.object().shape({
  NotificationPopupLinkMp4: Yup.string().required('انتخاب ویدیو برای اعلان ضروری است'),
});

export const getSchema = (selectedPopupType, popupHasButton) => {
  const schema = Yup.object().shape({
    ...baseSchema.fields,
    ...(popupHasButton && { ...buttonSchema.fields }),
    ...(selectedPopupType !== 7 && { ...imageSchema.fields }),
    ...(selectedPopupType === 6 && { ...linkMp4Schema.fields }),
    ...(![5, 6]?.includes(selectedPopupType) && { ...bodySchema.fields }),
  });

  return schema;
};
